// extracted by mini-css-extract-plugin
export default {"modal":"MI4AZiPZ1xTOCeHVHKos","container":"FIVgv9rrsf3Bi98XakPz","text":"Z1mFbiH6Hc4eSVDGBp2Q"};